import { Button } from '@hashicorp/react-mds/src/components/button'
import FlightIcon from '@hashicorp/react-hds/src/components/flight-icon'
import s from './style.module.css'

interface CourseProps {
	heading: string
	description: string
	cta: {
		title: string
		url: string
	}
	schedule: Array<{
		heading: string
		items: Array<string>
	}>
}

export interface CoursesProps {
	intro: {
		heading: string
		description: string
		items: Array<{
			iconName: string
			label: string
		}>
	}
	heading: string
	courses: Array<CourseProps>
}

export default function Courses({
	intro,
	heading,
	courses,
}: CoursesProps): JSX.Element {
	return (
		<section className={s.courses}>
			<header className={s.intro}>
				<div className={s.introInner}>
					<h2 className={s.introHeading}>{intro.heading}</h2>
					<p className={s.introDescription}>{intro.description}</p>
					<ul className={s.introItems}>
						{intro.items.map((item, index) => {
							return (
								<li key={index} className={s.introItem}>
									<span className={s.introItemIcon}>
										<FlightIcon name={item.iconName} size={24} />
									</span>
									<span className={s.introItemLabel}>{item.label}</span>
								</li>
							)
						})}
					</ul>
				</div>
			</header>
			<div className={s.content}>
				<div className={s.contentContainer}>
					<div className={s.contentInner}>
						<h3 className={s.heading}>{heading}</h3>
						{courses.map((course, index) => {
							return (
								<article key={index} className={s.course}>
									<header className={s.courseHeader}>
										<h4 className={s.courseHeading}>{course.heading}</h4>
										<p className={s.courseDescription}>{course.description}</p>
										<div className={s.courseCta}>
											<Button
												title={course.cta.title}
												url={course.cta.url}
												linkType="inbound"
												theme={{
													variant: 'tertiary',
													brand: 'neutral',
												}}
											/>
										</div>
									</header>
									<ol className={s.schedule}>
										{course.schedule.map((day, index) => {
											return (
												<li key={index} className={s.scheduleDay}>
													<h5 className={s.scheduleHeading}>{day.heading}</h5>
													<ul className={s.scheduleItems}>
														{day.items.map((item, index) => {
															return (
																<li key={index} className={s.scheduleItem}>
																	{item}
																</li>
															)
														})}
													</ul>
												</li>
											)
										})}
									</ol>
								</article>
							)
						})}
					</div>
				</div>
			</div>
		</section>
	)
}
